import * as React from 'react';

import * as styles from './styles.css';

export const Filters: React.FC = props => {
  return <div className={styles['container']}>{props.children}</div>;
};

Filters.displayName = 'Filters';
